export default __webpack_public_path__ + "static/media/shib.fd6f9cf5.webp";